import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { AuthGuard } from '../auth/auth-guard'

import { ProfileComponent } from './profile.component'
import { SettingsComponent } from './settings/settings.component'
import { UserProfileComponent } from './user-profile/user-profile.component'
import { BlockedListComponent } from './blocked-list/blocked-list.component'
import { LocationComponent } from './location/location.component'

const profileRoutes: Routes = [
  {
    path: 'profile/blocked',
    component: BlockedListComponent,
    canActivate: [ AuthGuard ]
  },
  {
    path: 'profile/:id',
    component: UserProfileComponent,
    canActivate: [ AuthGuard ]
  },
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [ AuthGuard ]
  },
  {
    path: 'settings',
    component: SettingsComponent,
    canActivate: [ AuthGuard ]
  },
  {
    path: 'location',
    component: LocationComponent,
    canActivate: [ AuthGuard ]
  }
]

@NgModule({
  imports: [
    RouterModule.forChild(profileRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class ProfileRoutingModule { }



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/profile/profile-routing.module.ts